import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { ThemeProvider } from "@/components/theme-provider"
import { App } from "./app"
import "@fontsource-variable/geist"
import "@fontsource-variable/hanken-grotesk"
import "./marketing/texly-baseline.css"
import "../app/globals.css"
import "./marketing/resolto-texly-overrides.css"

const savedTheme = localStorage.getItem("resolto-theme")
const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
document.documentElement.dataset.theme =
  savedTheme === "dark" || (savedTheme !== "light" && prefersDark) ? "dark" : "light"
document.documentElement.classList.toggle("dark", document.documentElement.dataset.theme === "dark")

const root = document.getElementById("root")
if (!root) throw new Error("Resolto root element is missing")

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
)
